export const selectItemDL = (catName: string, items: any, subsType: string, attorneySize: number) => {
  const subscription = (item: any) => item?.options.find((i: any) => i.title.includes(subsType)) 
  const event = {
    event: "select_item",
    ecommerce: {
      item_list_name: catName,
      items: items.map((item: any, index: number) => ({
        item_id: item.sku,
        item_name: item.name,
        index,
        price: subscription(item)?.drop_down_option[attorneySize]?.price,
        quantity: 1
      }))
    }
  }
  return event;
}

export const cartUpdateEventDL = (eventIdentifier: string, cartData: any) => {
  const event = {
    event: eventIdentifier,
    ecommerce: {
      currency: cartData?.prices?.grand_total?.currency,
      value: cartData?.prices?.grand_total?.value,
      items: cartData?.items?.map((item: any, index: number) => ({
        item_id: item?.product?.sku,
        item_name: item?.product?.name,
        index,
        price: item?.prices?.price?.value,
        quantity: item?.quantity
      }))
    }
  }
  return event;
}

export const cartValueEventDL = (eventIdentifier: string, cartData: any) => {
  const event = {
    event: eventIdentifier,
    ecommerce: {
      currency: cartData?.prices?.grand_total?.currency,
      value: cartData?.prices?.grand_total?.value,
      coupon: cartData?.applied_coupon?.code,
      items: cartData?.items?.map((item: any, index: number) => ({
        item_id: item?.product?.sku,
        item_name: item?.product?.name,
        index,
        price: item?.prices?.price?.value,
        quantity: item?.quantity,
        payment_type: "Online",
        shipping_tier: "Digital"
      }))
    }
  }
  return event;
}

export const purchaseEventDL = (order: any) => {
  const event = {
    event: "purchase",
    ecommerce: {
      transaction_id: order.order_id,
      tax: order?.tax_amount,
      value: order?.grand_total,
      discount: order?.discount_amount,
      items: order?.items.map((item: any, index: number) => ({
        item_id: item?.sku,
        item_name: item?.title,
        index,
        price: item?.price,
        payment_type: "Online",
        shipping_tier: "Digital"
      }))
    }
  }
  return event;
}

export const promotionEventDL = (eventIdentifier: string, cartData: any) => {
  const event = {
    event: eventIdentifier,
    ecommerce: {
      promotion: cartData?.applied_coupon?.code,
      items: cartData?.items.map((item: any, index: number) => ({
        item_id: item?.product?.sku,
        item_name: item?.product?.name,
        index,
        price: item?.prices?.price?.value,
        quantity: item?.quantity,
      }))
    }
  }
  return event;
}